import React from 'react'
import {Button} from 'react-bootstrap'
import Dropdown from 'react-bootstrap/Dropdown'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {useNavigate} from 'react-router-dom'
import {getRevenuePrefixPath} from '../../../utils/Helper'

interface IStepperButton {
  title: string
  state: 'pending' | 'passed' | 'disabled'
  counter?: number
  documents?: IIncomeDocument[]
  onClick?(): void
}

const StepperButton: React.FC<IStepperButton> = (props) => {
  const {title, state, documents, counter = 0, onClick} = props
  const navigate = useNavigate()

  const renderIcon = () => {
    if (state === 'passed') {
      return <i className='fa fa-check-circle'></i>
    }

    if (state === 'disabled') {
      return <i className='fas fa-circle-notch'></i>
    }

    if (state === 'pending') {
      return <i className='fas fa-plus-circle'></i>
    }
  }

  const _renderInnerContent = () => {
    return (
      <>
        {renderIcon()}
        {title}
        {counter > 1 && <span className={'-counter'}>{counter}</span>}
      </>
    )
  }

  return (
    <>
      {(documents?.length && documents?.length > 1) ? (
        <Dropdown className="d-inline">
          <Dropdown.Toggle id="dropdown-autoclose-true" className={`x-stepper-btn -${state}`}>
            {_renderInnerContent()}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {documents.map((doc) => {
              return (
                <Dropdown.Item
                  key={`doc-dropdown-${doc.code}`}
                  href="#"
                  className={'py-1'}
                  onClick={() => {
                    navigate(`${getRevenuePrefixPath(doc.type)}/${doc.id}/detail`)
                  }}
                >
                  {doc.code}
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Button
          className={`x-stepper-btn -${state}`}
          // ปุ่มที่ไม่มี handler ไม่ควรขึ้น cursor เป็นมือ ไม่งั้นดูเหมือนกดได้ทั้งที่กดแล้วเงียบ
          style={onClick ? undefined : {cursor: 'default'}}
          onClick={onClick}
        >
          {_renderInnerContent()}
        </Button>
      )}
    </>
  )
}

export default StepperButton
